import React, { useState, useEffect } from 'react'
import { Footer as ArgosFooter, BackToTop } from '@sainsburys-tech/bolt'
import ScrollPositionConsumer from '../../helpers/scrollPositionContext'

const Footer = () => {
  const [serverSideFooter, setFooterState] = useState(true)

  useEffect(() => {
    setFooterState(false)
  })

  return serverSideFooter ? (
    <ArgosFooter brandHidden serviceHidden socialappHidden />
  ) : (
    <ScrollPositionConsumer>
      {(context) => (
        <div>
          <div data-test='back-to-top'>
            <BackToTop />
          </div>
          <ArgosFooter scrollPosition={context && context.scrollPosition} />
        </div>
      )}
    </ScrollPositionConsumer>
  )
}

export default Footer
